import React from 'react'
import PropTypes from 'prop-types'
import { TextField, IconButton } from '@material-ui/core'
import ArrowUpward from '@material-ui/icons/ArrowUpward'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Delete from '@material-ui/icons/Delete'
import UploadImage from './UploadImage'
import styles from './ColourEditor.icss'
import arrayMove from '../utilities/arrayMove'

class ColourEditor extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			colourId: this.props.colourId || '',
			colourName: this.props.colourName || '',
			images: this.props.images || []
		}
		this.form = React.createRef()
		this.saveUploadedImageBinder = this.saveUploadedImageBinder.bind(this)
		this.moveImageUpBinder = this.moveImageUpBinder.bind(this)
		this.moveImageDownBinder = this.moveImageDownBinder.bind(this)
		this.deleteImageBinder = this.deleteImageBinder.bind(this)
	}

	saveUploadedImageBinder(colourIndex) {
		return (url) => {
			const images = this.state.images // eslint-disable-line react/no-access-state-in-setstate
			images.push({ url, imageProcessingRequired: true })

			this.setState({ images }, () => {
				this.props.saveUploadedImage({ url, colourIndex })
				this.props.onChange(this.state)
			})
		}
	}

	moveImageUpBinder(colourIndex) {
		return () => {
			const images = arrayMove([...this.state.images], colourIndex, colourIndex - 1) // eslint-disable-line react/no-access-state-in-setstate
			this.setState({ images }, () => this.props.onChange(this.state))
		}
	}

	moveImageDownBinder(colourIndex) {
		return () => {
			const images = arrayMove([...this.state.images], colourIndex, colourIndex + 1) // eslint-disable-line react/no-access-state-in-setstate
			this.setState({ images }, () => this.props.onChange(this.state))
		}
	}

	deleteImageBinder(colourIndex) {
		return () => {
			const images = [...this.state.images] // eslint-disable-line react/no-access-state-in-setstate
			images.splice(colourIndex, 1)
			this.setState({ images }, () => this.props.onChange(this.state))
		}
	}

	render() {
		const images = this.state.images
		return (
			<div className={styles.surround}>
				<section className={styles.fieldSurround}>
					<TextField
						name="colourName"
						value={this.state.colourName}
						onChange={e => this.setState({ colourName: e.target.value }, () => this.props.onChange(this.state))}
						onBlur={() => this.props.onBlur()}
						fullWidth
						margin="normal"
						label={this.context.translate('Colour')}
						error={this.props.error}
						helperText={this.props.helperText}
					/>
				</section>
				{images.map((itemImageContent, index) => (
					// eslint-disable-next-line react/no-array-index-key
					<div className={styles.imageSurround} key={`image-${index}-${itemImageContent.url || index}`}>
						<UploadImage
							classNames={{ surround: styles.buttonOnlySurround, wrapper: styles.buttonOnlyWrapper }}
							saveUploadedImage={this.saveUploadedImageBinder(this.props.colourIndex)}
							errorHandler={this.props.errorHandler}
							imageContent={itemImageContent}
							imgClass={styles.uploadedImage}
							showChangeButton={false}
						/>
						<div className={styles.buttonSurround}>
							<IconButton disabled={index === 0} aria-label="Context" onClick={this.moveImageUpBinder(index)}>
								<ArrowUpward />
							</IconButton>
							<IconButton disabled={index === (images.length - 1)} aria-label="Context" onClick={this.moveImageDownBinder(index)}>
								<ArrowDownward />
							</IconButton>
							<IconButton aria-label="Context" onClick={this.deleteImageBinder(index)}>
								<Delete />
							</IconButton>
						</div>
					</div>
				))}
				<div className={styles.imageSurround}>
					<UploadImage
						classNames={{ surround: styles.buttonOnlySurround, wrapper: styles.buttonOnlyWrapper }}
						hintText={this.context.translate('Add a photo of the {colourName} item', { colourName: this.state.colourName })}
						uploadedText={this.context.translate('Item photo uploaded')}
						saveUploadedImage={this.saveUploadedImageBinder(this.props.colourIndex)}
						errorHandler={this.props.errorHandler}
						imgClass={styles.uploadedImage}
						imgInline={false}
						showChangeButton={false}
					/>
				</div>
			</div>
		)
	}
}

ColourEditor.contextTypes = {
	translate: PropTypes.func
}

ColourEditor.propTypes = {
	saveUploadedImage: PropTypes.func.isRequired,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
	colourIndex: PropTypes.number,
	errorHandler: PropTypes.func.isRequired,
	colourId: PropTypes.string,
	colourName: PropTypes.string,
	images: PropTypes.arrayOf(PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }),
		PropTypes.arrayOf(PropTypes.shape({ type: PropTypes.string, webpurl: PropTypes.string, url: PropTypes.string }))
	])),
	error: PropTypes.bool,
	helperText: PropTypes.string
}

ColourEditor.defaultProps = {
	onChange: () => {},
	onBlur: () => {},
	images: undefined,
	colourIndex: undefined,
	colourName: undefined,
	colourId: undefined,
	error: false,
	helperText: undefined
}

// export default connectPropTypes(ColourEditor)
export default ColourEditor



// WEBPACK FOOTER //
// ./src/components/ColourEditor.jsx